// AnimationTest.tsx

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import menStartTestImage from '../../assets/images/men-start-test.png';
import IconNext from '../Icons/IconNext';
import IconPro from '../Icons/IconPro';
import './PriceCalculator.css';

interface Props {
  onStartButtonClick: () => void;
}

const AnimationTest: React.FC<Props> = ({ onStartButtonClick }) => {
  const {t} = useTranslation()
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    document.body.classList.add('dark-overlay');
    const animationContainer = document.querySelector('.animationTest__container');
    if (animationContainer) {
      animationContainer.classList.add('activate-overlay');
    }
  }, []);

  const handleNextButtonClick = () => {
      document.body.classList.remove('dark-overlay');
      const animationContainer = document.querySelector('.animationTest__container');
      if (animationContainer) {
        animationContainer.classList.remove('activate-overlay');
        onStartButtonClick();
      }
  };

  const handleNextStepButtonClick = () => {
    setCurrentStep(currentStep + 1);
  };

  return (
    <div className="animationTest__container">
      <div className={`animationTest__box ${currentStep === 1 ? 'animationTest__box--active' : ''}`}  >
        <span className='animationTest__title'>{t('price_calculator.initial_screen.step_1.title')} 
        </span>
        <p className='animationTest__p'>{t('price_calculator.initial_screen.step_1.description')}</p>
        <div className='exporter-test__container-footer'>
          <div className="animationTest__next" onClick={handleNextStepButtonClick}>
            <div className="animationTest__next-text">{t('price_calculator.initial_screen.step_1.button')}
            </div>
            <IconNext className='animationTest__next-icon' />
          </div>
          <div className="animationTest__pagination">
            <div className="animationTest__pagination-item active"></div>
            <div className="animationTest__pagination-item"></div>
          </div>
        </div>
      </div>
      <div className={`animationTest__box ${currentStep === 2 ? 'animationTest__box--active' : ''}`}>
        <span className='animationTest__title'> <div dangerouslySetInnerHTML={{ __html: t('price_calculator.initial_screen.step_2.title') }} />
        <IconPro className='animationTest__title-icon' fill='#BBC2C7' />
        </span>
        <p className='animationTest__p'>{t('price_calculator.initial_screen.step_2.description')}</p>
        <div className='exporter-test__container-footer'>
          <div className="animationTest__next" onClick={handleNextButtonClick}>
            <div className="animationTest__next-text">{t('price_calculator.initial_screen.step_2.button')}</div>
          </div>
          <div className="animationTest__pagination">
            <div className="animationTest__pagination-item"></div>
            <div className="animationTest__pagination-item active"></div>
          </div>
        </div>
      </div>
      <div className="animationTest__image-container">
        <img src={menStartTestImage} alt="Men Start Test" />
      </div>
    </div>
  );
};

export default AnimationTest;
